@if (task() && response) {
  <div class="responseDetail">
    <h3 class="responseHeader">{{ task().name }}</h3>
    <div class="inputRow">
      <span class="inputLabel">
        <label>Entity ID</label>
      </span>
      <span class="inputField">
        <label>{{ task().entityId }};{{ task().entityRevision }}</label>
      </span>
    </div>
    <div class="inputRow">
      <span class="inputLabel">
        <label>Expedite Parts</label>
      </span>
      <span class="inputField">
        <label>{{ expediteParts() ? 'Yes' : 'No' }}</label>
      </span>
    </div>
    <div class="inputRow">
      <span class="inputLabel">
        <label>Partial Shipments Allowed</label>
      </span>
      <span class="inputField">
        <label>{{ partialShipments() ? 'Yes' : 'No' }}</label>
      </span>
    </div>
    <div class="inputRow">
      <span class="inputLabel">
        <label>Ship Date</label>
      </span>
      <span class="inputField">
        <input [matDatepicker]="shipDatePicker" name="shipDateInput" [value]="formatShipDate()"
          (dateChange)="setShipDate($event.value)"/>
        <mat-datepicker-toggle [for]="shipDatePicker"></mat-datepicker-toggle>
        <mat-datepicker id="shipDatePicker" name="shipDatePicker" #shipDatePicker></mat-datepicker>
      </span>
    </div>
    <div class="toolbar">
      <span class="spacer"></span>
      <span>
        <button class="primary-button" matButton="elevated" [disabled]="!response || isBusy()" (click)="saveResponse()">
          <span>
            <mat-icon class="size-16">done</mat-icon>
            <label>Complete Task</label>
          </span>
        </button>
      </span>
    </div>
  </div>
}
@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}

